import React from "react";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import TargetClearCountField from "./TargetClearCountField";

const TargetClearCountSection = ({
  targetClearCount,
  setTargetClearCount,
}: {
  targetClearCount: number;
  setTargetClearCount: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit_target.section.target_clear_count")}
      rows={[
        {
          label: t(
            "quest_edit_target.field.target_clear_count.target_clear_count.name",
          ),
          required: true,
          children: (
            <TargetClearCountField
              targetClearCount={targetClearCount}
              setTargetClearCount={setTargetClearCount}
            />
          ),
        },
      ]}
    />
  );
};

export default TargetClearCountSection;
